import { Component, OnDestroy, OnInit } from '@angular/core';
import { CustomerType } from '../../../../models/client-configuration';
import { ConfigService } from '../../../../services/config.service';
import { EventsModel, UserEvents } from '../../../../services/user-events/models/user-events.model';
import { Subscription } from 'rxjs';
import { LocaleService } from '../../../../services/locale.service';
import { Router } from '@angular/router';
import { UserEventsService } from '../../../../services/user-events/user-events.service';
import { filter } from 'rxjs/operators';
import dayjs from 'dayjs';
import { SearchModel } from 'src/app/models/search-model';

@Component({
  selector: 'app-header-events-button',
  templateUrl: './header-events-button.component.html',
  styleUrls: ['./header-events-button.component.scss']
})
export class HeaderEventsButtonComponent implements OnInit, OnDestroy {
  private userEventsSubscription: Subscription;

  customerType: CustomerType;
  currentDay: Date;
  currentDayWithFormat: string;
  showTodayEvents: boolean;
  textDirection: string;
  userEvents: UserEvents;
  userEventsToday: EventsModel[];

  constructor(
    private readonly configService: ConfigService,
    private readonly localeService: LocaleService,
    private readonly router: Router,
    private readonly userEventsService: UserEventsService,
  ) { }

  ngOnInit(): void {
    this.currentDay = new Date();
    this.currentDayWithFormat = dayjs(new Date()).format('YYYY-MM-DD');
    this.customerType = this.configService.customerType;
    this.textDirection = this.localeService.getTextDirection();

    this.userEventsSubscription = this.userEventsService.userEvents$
      .pipe(filter(value => value !== null))
      .subscribe((userEvents) => {
        this.userEvents = userEvents;

        this.userEventsToday = userEvents.dayEvents.filter((event) => {
          return dayjs(event.date).format('YYYY-MM-DD') === this.currentDayWithFormat && event.events.length > 0;
        });

        this.showTodayEvents = userEvents.showEvents && userEvents.dayEvents.length > 0;
      })
  }

  loadUserEvents() {
    if (this.configService.get().showEventsSection) {
      this.userEventsService.userEventEndpoint().subscribe();
    }
  }

  goToEventsSection() {
    this.router.navigate(['/user/events']);
  }

  ngOnDestroy() {
    this.userEventsSubscription?.unsubscribe();
  }

  exploreLearningExperiences() {
    const model = new SearchModel();
    model.explore = true;

    this.router.navigate(['/results'], {
      queryParams: model.toRequestLearningExperiences(),
    });
  }
}
